module.exports = __webpack_public_path__ + "img/2d-wj.3c39f06.png";